/*    
<summary>
    This functional common component provides modal popup that shows delete confirmation message (i.e. are you sure 
    want to delete).    
    Developer:Mohammad Saquib Khan, Created Date:15-Sept-2025
</summary>
<returns>Returns JSX</returns>
*/
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

interface Props {
  modalClosed: () => void;
  isLoading: boolean;
  title: string;
  message?: string;
  className?: string;
  note?: string;
}

const RegisterCustomerAlreadyExistsPopup: React.FC<Props> = (props) => {
  return (
    <Modal dialogClassName="delete_popup " show={true} centered>
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id={props.title} />
          <button
            onClick={props.modalClosed}
            disabled={props.isLoading}
            className="Crossicons"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="bootbox-body text-center">
          <FormattedMessage id={props.message} />
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button
          variant="danger"
          onClick={props.modalClosed}
          disabled={props.isLoading}
          className="btnOkSize"
        >
          <FormattedMessage id="ok" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RegisterCustomerAlreadyExistsPopup;
